import type { AlgoliaProduct } from '@algolia-search/types';
import { defineStore } from 'pinia';

interface PurchasedProduct extends AlgoliaProduct {
  quantity: number;
}

const getPrimarySku = (product: AlgoliaProduct | PurchasedProduct): string => {
  return Array.isArray(product.sku) ? product.sku[0] : product.sku;
};

export const useAlgoliaPurchaseTracking = defineStore('search-purchase-tracking', {
  state: () => ({
    lastPurchasedHits: [] as PurchasedProduct[]
  }),
  persist: true,
  actions: {
    fetchPurchasedHitsBySKUs(skus: string[]): PurchasedProduct[] {
      const skuSet = new Set(skus);
      return this.lastPurchasedHits.filter((hit) => skuSet.has(getPrimarySku(hit)));
    },
    addPurchasedHit(hit: AlgoliaProduct, quantity = 1): void {
      const sku = getPrimarySku(hit);
      const existingHit = this.lastPurchasedHits.find((h) => getPrimarySku(h) === sku);

      if (existingHit) {
        existingHit.quantity += quantity;
      } else {
        this.lastPurchasedHits.push({ ...hit, quantity });
      }
    },
    clearPurchasedHits(): void {
      this.lastPurchasedHits = [];
    }
  },
  getters: {
    hasPurchasedHits: (state): boolean => state.lastPurchasedHits.length > 0
  }
});
